import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CourseItem from "../card/CourseItem";
import { useSelector } from "react-redux";
import { courseMaterialUrl, imageSrc } from "../../../../helpers/url_helper";
import { addDays, format, parseISO } from "date-fns";

function MyCourseCarousel({courses}) {
  const paths      = useSelector((state) => state.user.paths);
  const ref        = useRef(null);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1, 
          rows: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2, 
          rows: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1368,
        settings: {
          slidesToShow: 2, 
          rows: 2,
          variableWidth: false,
        },
      }
    ],
  };
  
  const courseData = courses && Object.keys(courses).length > 0 && courses.map((value) => {
  const deadlineDate = value?.cs_course_validity_status === '0' ? 'Lifetime Validity' :
                       value?.cs_end_date ? 'Deadline : ' + format(parseISO(value?.cs_end_date), 'MMM d, yyyy') :
                       'Lifetime Validity';
    const isExpired = value?.cs_course_validity_status === '0' ? false : value?.cs_end_date && parseISO(value.cs_end_date).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) ? false : true;
    return {
      className: isExpired ? 'expired' : '',
      courseImage: imageSrc('course',value.cb_image, paths),
      courseType: value?.item_type,
      courseTitle: value?.cb_title,
      courseDeadline: deadlineDate,
      courseLectureCount: `${value?.lecture_count ?? 0} Lecture${value?.lecture_count > 1 ? "s":""}`,
      courseTypeLearning: value?.category,
      courseStartLink: courseMaterialUrl(value.cs_course_id,0,`student-dashboard/courses/details/${value?.cb_slug}`, false) ?? '',
      courseResumeLink: value.last_played_lecture !== null ? courseMaterialUrl(value?.cs_course_id,value?.cs_last_played_lecture,`student-dashboard/courses/detail/${value?.cb_slug}`, false) : '',
      courseDetailLink: `/student-dashboard/courses/detail/${value?.cb_slug}` ?? '',
      isExpired: isExpired ? 'expired' : ''
    }
  });
  
  return (
    <>
      <Slider {...settings} ref={ref}>
        {courseData && courseData.map((course, index) => (
          <CourseItem key={index} {...course} />
        ))}
      </Slider>
    </>
  );
}

export default MyCourseCarousel;
